import axios from 'axios';
import { PhotoActionTypes } from './';
import Auth from '../auth/auth';
import { unstable_renderSubtreeIntoContainer } from 'react-dom';

const endpoint = `${process.env.REACT_APP_EYS_API_HOST}/photo`;
const auth = new Auth({});

export function findPhotos(username) {
  const request = axios.get(`${endpoint}?order=date&ascDesc=desc&page=1&perPage=1000000&assigneeUserName=${username}`);
  return {
    type: PhotoActionTypes.FIND,
    payload: request
  };
}


export function findPhotosByIds(username, photoIds, callback, errorCallback) {

  const request = axios.get(`${endpoint}?order=date&ascDesc=desc&page=1&perPage=1000000&assigneeUserName=${username}&photoIds=${photoIds}`);

  if (callback) {
    request.then((response) => callback(response));
  }

  if (errorCallback) {
    request.catch((error) => errorCallback(error));
  }

  return {
    type: PhotoActionTypes.FINDBYID,
    payload: request
  };
}




// WEBPACK FOOTER //
// ./src/actions/photo.action.js